


















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ApdSurveilansService from "@/services/ApdSurveilansService";

@Component
export default class ApdSurveilansDetail extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;
  jenisList: any[] = [];

  signDialog = false;
  signStage: "auditor" | "kaunit" | "komite_ppi" | "pimpinan" | null = null;
  signPassword = "";
  signing = false;

  temuanDialog = false;
  temuanForm: any = {};
  savingTemuan = false;

  userIsKomitePpi = false; // TODO: check via auth user role

  obsHeaders = [
    { text: "#", value: "urutan", width: 40 },
    { text: "Waktu", value: "waktu" },
    { text: "Petugas", value: "nama_petugas" },
    { text: "Profesi", value: "profesi_jabatan" },
    { text: "Tindakan", value: "tindakan" },
    { text: "Wajib/Patuh", value: "total_apd_wajib", width: 90 },
    { text: "Compliance", value: "compliance_percent" }
  ];

  temuanHeaders = [
    { text: "#", value: "urutan", width: 40 },
    { text: "Temuan", value: "temuan_text" },
    { text: "APD", value: "apd_terkait.nama" },
    { text: "RTL", value: "rencana_tindak_lanjut" },
    { text: "Target", value: "target_selesai" },
    { text: "Status", value: "status_tindak_lanjut" }
  ];

  signStages = [
    {
      key: "auditor",
      label: "Auditor / Tim PPI",
      nameField: "auditor_nama",
      timestampField: "signed_auditor_at",
      canSign: (s: any) => !s.signed_auditor_at
    },
    {
      key: "kaunit",
      label: "Kepala Ruangan / Unit",
      nameField: "signed_kaunit_nama",
      timestampField: "signed_kaunit_at",
      canSign: (s: any) => !!s.signed_auditor_at && !s.signed_kaunit_at
    },
    {
      key: "komite_ppi",
      label: "Ketua Komite PPI",
      nameField: "signed_komite_ppi_nama",
      timestampField: "signed_komite_ppi_at",
      canSign: (s: any) => !!s.signed_kaunit_at && !s.signed_komite_ppi_at
    },
    {
      key: "pimpinan",
      label: "Direktur / Pimpinan",
      nameField: "signed_pimpinan_nama",
      timestampField: "signed_pimpinan_at",
      canSign: (s: any) => !!s.signed_komite_ppi_at && !s.signed_pimpinan_at
    }
  ];

  get signStageLabel() {
    return this.signStages.find(s => s.key === this.signStage)?.label || "";
  }

  async mounted() {
    await Promise.all([this.loadSession(), this.loadJenis()]);
  }

  async loadSession() {
    const res = await ApdSurveilansService.find(this.sessionId);
    this.session = res.data.data;
  }

  async loadJenis() {
    const res = await ApdSurveilansService.getJenis();
    this.jenisList = res.data.data;
  }

  apdName(kode: string): string {
    return this.jenisList.find(j => j.kode === kode)?.nama || kode;
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  formatDateTime(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleString("id-ID");
  }

  printPdf() {
    ApdSurveilansService.printPdf(this.session.id);
  }

  openSignDialog(stage: "auditor" | "kaunit" | "komite_ppi" | "pimpinan") {
    this.signStage = stage;
    this.signPassword = "";
    this.signDialog = true;
  }

  async confirmSign() {
    if (!this.signStage) return;
    this.signing = true;
    try {
      const handlers = {
        auditor: ApdSurveilansService.submitAuditor,
        kaunit: ApdSurveilansService.approveKaunit,
        komite_ppi: ApdSurveilansService.approveKomitePpi,
        pimpinan: ApdSurveilansService.approvePimpinan
      };
      await handlers[this.signStage](this.session.id, { password: this.signPassword });
      this.signDialog = false;
      await this.loadSession();
    } finally {
      this.signing = false;
    }
  }

  openTemuan(t?: any) {
    this.temuanForm = t
      ? { ...t }
      : {
          temuan_text: "",
          apd_terkait_id: null,
          akar_masalah: "",
          rencana_tindak_lanjut: "",
          target_selesai: "",
          status_tindak_lanjut: "open"
        };
    this.temuanDialog = true;
  }

  async saveTemuan() {
    this.savingTemuan = true;
    try {
      if (this.temuanForm.id) {
        await ApdSurveilansService.updateTemuan(
          this.session.id,
          this.temuanForm.id,
          this.temuanForm
        );
      } else {
        await ApdSurveilansService.storeTemuan(this.session.id, this.temuanForm);
      }
      this.temuanDialog = false;
      await this.loadSession();
    } finally {
      this.savingTemuan = false;
    }
  }
}
